import { useQueryClient } from "react-query";
import { useContext, useState } from "react";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { ToastContext } from "../../../../../../hooks/context";
import { useApproveOrRejectGRMutation } from "../../../../../../hooks/api/mutations";

export const useGoodsReceivedDetails = () => {
  const queryClient = useQueryClient();
  const triggerToast = useContext(ToastContext);
  const { search, setSearch } = useUrlSearch();
  const [views, setViews] = useState({
    isAcceptDialog: false,
    isRejectDialog: false,
  });

  const { mutate: approveOrRejectGR, isLoading: isUpdatingStatus } =
    useApproveOrRejectGRMutation();

  const handleApproveOrRejectGR = (id, status) => {
    approveOrRejectGR(
      { id, data: { status } },
      {
        onSuccess: () => {
          const message =
            status === "ACCEPTED"
              ? "GRN Approval Successful"
              : "GRN Rejection Successful";
          triggerToast(message, "success");
          queryClient.invalidateQueries(["getGoodsReceivedDetails", `${id}`]);
          setViews({
            isAcceptDialog: false,
            isRejectDialog: false,
          });

          if (status === "ACCEPTED") {
            search.set("new_approved_gr_id", id);
            setSearch(search, { replace: true });
          }
        },
      },
    );
  };

  return {
    isUpdatingStatus,
    views,
    search,
    setViews,
    handleApproveOrRejectGR,
  };
};
